import React, { useState } from 'react';
import { Maximize2, Download } from 'lucide-react';
import PdfFlipbook from './PdfFlipbook';
import FlipbookModal from './FlipbookModal';
import Countdown from './Countdown';

export default function ReportViewer({ url, eyebrow, title, intro, accent, bg, testid, nextAt, nextLabel }) {
  const [full, setFull] = useState(false);
  return (
    <section id={testid} className="section-pad py-14 scroll-mt-24" data-testid={testid}>
      <div className="max-w-[1500px] mx-auto rounded-3xl p-5 md:p-10" style={{ background: bg }}>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-8 text-white">
          <div className="max-w-2xl">
            <p className="eyebrow mb-3" style={{ color: accent }} data-testid={`${testid}-edition`}>{eyebrow}</p>
            <h2 className="font-display text-3xl md:text-5xl">{title}</h2>
            <p className="text-white/70 mt-3">{intro}</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <button onClick={() => setFull(true)} data-testid={`${testid}-fullscreen`} className="inline-flex items-center gap-2 font-semibold px-5 py-3 rounded-full text-white transition-opacity hover:opacity-85" style={{ background: accent }}><Maximize2 size={17} /> Read full screen</button>
            <a href={url} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-download`} className="inline-flex items-center gap-2 border border-white/40 text-white font-medium px-5 py-3 rounded-full hover:bg-white/10 transition-colors"><Download size={17} /> PDF</a>
          </div>
        </div>
        <Countdown at={nextAt} label={nextLabel} accent={accent} testid={`${testid}-countdown`} />
        <PdfFlipbook url={url} />
      </div>
      <FlipbookModal open={full} onClose={() => setFull(false)} url={url} title={`${title} · ${eyebrow}`} />
    </section>
  );
}
